export default "__VITE_ASSET__Dpdjto13__"